// extracted by mini-css-extract-plugin
export var resizer = "_dq-0";